import { render, staticRenderFns } from "./ReferenceContentBlockForm.vue?vue&type=template&id=3d8b5df3&"
import script from "./ReferenceContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./ReferenceContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports